import React, { Component, Fragment } from "react";
import { getSdk } from "../../services/sdkService";
import { withFocusable, Text, Loading, ModalSettings } from "../../services/visualLibraryService";
import { HeadingStyled, HeadingNoContentStyled, NoContentStyled, ButtonStyled } from "./styled/Styled";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { playHandler, play } from "../../utils/mediaDataRetrieval";
import { goToDetailPage } from "../../utils/goToDetailPage";
import { isUserSubscribedToChannel, isAddonContent, isChampionsTrophyAddOn } from "../../utils/subscriptionUtils";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { getAppState, withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonInfo, getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { config } from "../../config/config";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";
import { showForceLogoutError } from "../../services/modalsService";
import { starzRevamp as Theme } from "starz-visual-themes";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { ButtonStyled as ModalButtonStyled } from "../../components/ModalSettings/styles/Styled";
import * as Sentry from "@sentry/browser";
import { showExpiredContentModal } from "../../services/modalsService";
import {
  isTVODContent,
  isSVODContent,
  isTVODPriority,
  isContentActive,
  pramsYouborra,
  redirectToBuyBrandsPage,
  setCurrentStatusForPlayer,
  isTvodFlowForPlayback,
  isTvodExpired,
  getAssetPrices
} from "../../utils/tvodUtils";
import { getTVODAssetsStatus } from "../../services/tvodService";

const WATCHLIST = "watchlist";
const MYSTARZLIST = "mystarzlist";
const PAGE = "myLibrary";
const PLAY_FROM_LABEL = "cw_my_library";
const defaultFocusPath = "watchlistCarousel";
const TypedCarouselFocus = withFocusable(TypedCarouselStyled);
const ButtonFocus = withFocusable(ButtonStyled);
const ButtonModalFocus = withFocusable(ModalButtonStyled);
let CONTINUE_WATCHING;
let carouselSettings;
let medialistConfig;

function showNoContent(title, fn, isAccessLimitedByParentalLevel) {
  return (
    <NoContentStyled>
      {title && <HeadingNoContentStyled rank={2} text={title} />}
      <Text text={i18n.get("pages.myLibrary.emptyList")} />
      {!isAccessLimitedByParentalLevel && (
        <Fragment>
          <Text text={i18n.get("pages.myLibrary.whatToWatch")} />
          <Text text={`${i18n.get("pages.myLibrary.checkOurLatest")}:`} />
          <ButtonFocus
            label={i18n.get("global.media.movies")}
            focusPath={"buttonMoviesPath"}
            onClick={() => {
              fn("movies");
            }}
            size="small"
          />
          <ButtonFocus
            label={i18n.get("global.media.series")}
            focusPath={`${title ? title : ""}buttonSeriesPath`}
            onClick={() => {
              fn("series");
            }}
            size="small"
          />
        </Fragment>
      )}
    </NoContentStyled>
  );
}

class MyLibraryPage extends Component {
  constructor(props) {
    super(props);
    CONTINUE_WATCHING = i18n.get("pages.myLibrary.continueWatching");
    carouselSettings = {
      watchlist: {
        type: WATCHLIST,
        title: CONTINUE_WATCHING,
        name: CONTINUE_WATCHING
      },
      mystarzlist: {
        type: "layout",
        title: i18n.get("pages.myLibrary.myWatchlist"),
        name: WATCHLIST
      }
    };
    medialistConfig = {
      scope: "deep",
      pageSize: config.get().mediaListPageSize || 999 // Max results limited by spx
    };
    this.sections = {};
    this.carousels = {};
    this.videoConfig = {};
    this.play4KModalFocusPath = null;
    this.playFromLabel = PLAY_FROM_LABEL;
    this.onChangeItem = this.onChangeItem.bind(this);
    this.onClickButton = this.onClickButton.bind(this);
    this.loadCarousel = this.loadCarousel.bind(this);
    this.loadData = this.loadData.bind(this);
    this.getInitialSlide = this.getInitialSlide.bind(this);
    this.onLeft = this.onLeft.bind(this);
    this.onRight = this.onRight.bind(this);
    this.onEnterPlay = this.onEnterPlay.bind(this);
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.close4KModal = this.close4KModal.bind(this);
    this.state = {
      mystarzlist: null,
      watchlist: null,
      isEmpty: false,
      modal4K: false,
      didPlayerLaunch: false,
      isLoading: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.isEmpty !== this.state.isEmpty ||
      nextState.mystarzlist !== this.state.mystarzlist ||
      nextState.watchlist !== this.state.watchlist ||
      nextState.modal4K !== this.state.modal4K ||
      nextState.isLoading !== this.state.isLoading
    );
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
    this.props.stateActions.setCarouselItemFocus(0);
  }

  onBack() {
    if (getAppState().globalModal) {
      this.props.stateActions.hideGlobalModal();
      return false;
    }
    if (this.state.modal4K) {
      // Close 4K prompt.
      this.close4KModal();
    } else if (this.state.didPlayerLaunch) {
      // Cancel player launch
      this.setState({ didPlayerLaunch: false });
      this.props.resumeNavigation();
    } else {
      return false;
    }
    return true;
  }

  onEnterPlay(is4K = false) {
    if (this.state.didPlayerLaunch) {
      return;
    }
    this.setState({ didPlayerLaunch: true });
    play.bind(this, is4K)();
    this.props.pauseNavigation();
  }

  onChangeItem(index) {
    this.props.stateActions.setCarouselItemFocus(index);
  }

  onClickButton(section) {
    this.props.history.push({
      pathname: `/${section}`
    });
  }

  onLeft(type) {
    this.sections[type].left();
  }

  onRight(type) {
    this.sections[type].right();
  }

  getInitialSlide(type) {
    if (type === WATCHLIST) {
      return 0;
    }
    return this.props.initialFocus !== `${type}Carousel` ? 0 : this.props.applicationState.focusedCarouselItemIndex;
  }

  loadCarousel(list, type) {
    if (list && list.titles && list.titles.length > 0) {
      const carouselType = carouselSettings[type].type;
      return (
        <TypedCarouselFocus
          type={carouselType}
          items={getTitlesFormattedForCarousels.call(this, carouselType, list.titles)}
          title={carouselSettings[type].title}
          focusPath={`${type}Carousel`}
          initialSlide={this.getInitialSlide(type)}
          innerRef={carouselRef => {
            this.carousels[type] = carouselRef;
          }}
          onRef={ref => (this.sections[type] = ref)}
          slideMargin={Theme.components.carousel.slideMargin.layout}
          onEnterPress={this.handleEnter.bind(this, type)}
          onChangeItem={this.onChangeItem}
          marginBottom={props => props.theme.spacing.medium}
          onLeft={this.onLeft.bind(this, type)}
          onRight={this.onRight.bind(this, type)}
          direction={i18n.getDirection()}
        />
      );
    } else {
      return showNoContent(carouselSettings[type].title, this.onClickButton, isAccessLimitedByParentalLevel());
    }
  }

  getDataToSentBuyAsset(videoData = null) {
    return {
      title: videoData.title,
      addonContent: videoData.addonContent,
      titleId: videoData.id,
      price: null
    };
  }

  tvodBtnText(assetPrices) {
    let rentLabel;
    let oldRentLabel;
    let purchaseLabel;
    let oldPurchaseLabel;

    const rentCtaData = {};
    const purchaseCtaData = {};

    if (assetPrices && assetPrices.length !== 0) {
      assetPrices.forEach(price => {
        if (price.isRentId === true) {
          rentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.newPriceId = price.priceProduct;
          rentCtaData.newPrice = price.amount;
          rentCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldRentId === true) {
          oldRentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.oldPriceId = price.priceProduct;
          rentCtaData.oldPrice = price.amount;
          rentCtaData.oldPriceCurrency = price.currency;
        }
        if (price.isPurchaseId === true) {
          purchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.newPriceId = price.priceProduct;
          purchaseCtaData.newPrice = price.amount;
          purchaseCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldPurchaseId === true) {
          oldPurchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.oldPriceId = price.priceProduct;
          purchaseCtaData.oldPrice = price.amount;
          purchaseCtaData.oldPriceCurrency = price.currency;
        }
      });
    }
    return { rentLabel, oldRentLabel, rentCtaData, purchaseLabel, oldPurchaseLabel, purchaseCtaData };
  }

  async handleEnter(carouselName) {
    let onlineContent = "online";
    const {
      applicationState: { userAccountStatus, country, addons }
    } = this.props;
    const sdk = await getSdk();
    const videoData = this.sections[carouselName].handleAction();
    this.props.stateActions.setPosterLandscapeImage(
      (videoData && videoData.images && videoData.images.posterLandscape) || ""
    );
    const { id, tagList, progress, seriesId, addonContent } = videoData;
    const isTVOD =
      (videoData.assetTypes &&
        videoData.assetTypes.length > 0 &&
        isTVODContent(videoData.assetTypes) &&
        isTVODPriority(videoData.assetTypesPriority)) ||
      false;

    this.videoConfig = {
      id,
      tagList,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      addonContent,
      onlineContent
    };
    if (carouselName === WATCHLIST) {
      let contentType = "SVOD";
      let isSVOD = isSVODContent(videoData.assetTypes) || false;
      const isAssetActive = isSVOD ? isContentActive(addons, addonContent) : false;

      let isTVODFlow = false;
      if (isTVOD && !isAssetActive) {
        this.setState({
          isLoading: true
        });
        const contentId = seriesId ? seriesId : id;
        const status = await getTVODAssetsStatus(contentId);
        if (status && status.length > 0 && isTvodFlowForPlayback(status)) {
          isTVODFlow = true;
          setCurrentStatusForPlayer(status);
          const license = {
            type: status[0].subscriptionType,
            state: status[0].status
          };
          contentType = pramsYouborra(isTVOD, license);
        } else if (status && (status.length === 0 || (status.length > 0 && isTvodExpired(status)))) {
          const titleData = await sdk.mediaManager.getTitle(contentId);
          if (titleData) {
            const contentPrices = await getAssetPrices(titleData, country, isTVOD, status);
            const priceData = this.tvodBtnText(contentPrices);
            this.setState({
              assetPrices: priceData,
              titleData,
              title: titleData.title,
              id: titleData.id,
              addonContent: titleData.addonContent
            });
            const modifiedPriceData = { isOnMyList: true, ...priceData };
            this.setState({
              isLoading: false
            });
            return showExpiredContentModal.call(this, this.closeModal, modifiedPriceData);
          }
        }
      }
      if (isSVOD && !isTVODFlow) {
        if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
        }
        if (!isUserSubscribedToChannel(addons, addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(videoData));
        }
      }
      this.setState(
        {
          isLoading: true
        },
        async () => {
          const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
          this.setState({ isLoading: false });
          if (!isThisDeviceSupported) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
          }

          trackEvent(
            "continue watching-my library",
            `play-${this.sections[carouselName].selectedIndex + 1}`,
            seriesId || id
          );
          this.videoConfig = { ...this.videoConfig, contentType };
          playHandler.call(this, this.videoConfig);
        }
      );
    } else {
      trackEvent("my watchlist-my library", `click-${this.sections[carouselName].selectedIndex + 1}`, seriesId || id);
      goToDetailPage.call(this, { id, tagList, sectionName: PAGE.toLowerCase() });
    }
  }

  closeModal() {
    const {
      stateActions: { hideGlobalModal },
      setFocus
    } = this.props;
    hideGlobalModal();
    setFocus(defaultFocusPath);
    this.setState({
      isLoading: false
    });
  }

  async loadData(callback) {
    try {
      const sdk = await getSdk();
      const fields = "id,title,thumbnails,tags,tagIds,peg$AddonContent";
      const watchlist = sdk.mediaManager.getUserMediaLists(
        {
          ...medialistConfig,
          maxSeriesEpisodes: 1,
          listName: WATCHLIST,
          fields:
            "id,seriesId,title,tvSeasonNumber,tvSeasonEpisodeNumber,description,shortDescription,thumbnails,guid,media.expirationDate,media.availableDate,media.content.releases.pid,media.content.releases.url,media.content.assetTypes,media.content.streamingUrl,media.content.duration,tags,tagIds,peg$FourkProgramId,peg$AddonContent,peg$AssetTypes,peg$AssetTypesPriority"
        },
        !getAppState().isOnline
      );

      const mystarzlist = sdk.mediaManager.getUserMediaLists(
        {
          ...medialistConfig,
          fields,
          listName: MYSTARZLIST
        },
        !getAppState().isOnline
      );
      Promise.all([watchlist, mystarzlist])
        .then(result => {
          const userWatchlist = result[0];
          const userStarzlist = result[1];
          this.setState(
            {
              watchlist: userWatchlist.media_lists[0] || [],
              mystarzlist: userStarzlist.media_lists[0] || [],
              isEmpty:
                (!userWatchlist.media_lists.length || !userWatchlist.media_lists[0].titles.length) &&
                (!userStarzlist.media_lists.length || !userStarzlist.media_lists[0].titles.length)
            },
            callback
          );
        })
        .catch(error => {
          Sentry.captureException(error);
          const retry = () => {
            this.props.stateActions.hideGlobalModal();
            this.loadData();
          };

          const back = () => {
            this.props.stateActions.hideGlobalModal();
            this.props.history.goBack();
          };
          if (getAppState().isOnline && error.message.indexOf("timeout") > -1) {
            this.props.stateActions.showGlobalModal(
              getInternetConnectivityModalConfig.call(this, {
                retryImplementation: retry,
                backImplementation: back,
                needsDismissableProp: false,
                isTimeout: true
              })
            );
          } else if (!getAppState().isOnline && !error.status && !error.response) {
            this.props.stateActions.showGlobalModal(
              getInternetConnectivityModalConfig.call(this, {
                retryImplementation: retry,
                backImplementation: back
              })
            );
          } else {
            const buttons = [
              {
                ...getGlobalButtonInfo("retry"),
                buttonHandler: retry
              },
              {
                ...getGlobalButtonInfo("back"),
                buttonHandler: back
              }
            ];
            this.handleForcelogout(error);
            this.props.stateActions.showGlobalModal({
              modalText: i18n.get("global.errors.genericError"),
              buttons
            });
          }
          this.props.setFocus(getGlobalButtonFocusPath("retry"));
          return false;
        });
    } catch (error) {
      this.handleForcelogout(error);
    }
  }

  async handleForcelogout(error) {
    await this.props.stateActions.setForceLogout(error);
    // if Force logout show the popup
    if (!!getAppState().forceLogout) {
      this.props.resumeNavigation();
      await showForceLogoutError.call(this);
      return;
    }
  }

  async componentDidMount() {
    trackPage(PAGE);
    this.props.onRef(this);
    this.props.resumeNavigation();
    this.loadData(() => {
      if (
        this.state.isEmpty ||
        !this.state.watchlist ||
        !this.state.watchlist.titles ||
        !this.state.watchlist.titles.length
      ) {
        this.props.setFocus("buttonMoviesPath");
      } else {
        this.props.setFocus(defaultFocusPath);
      }
    });
  }

  close4KModal() {
    this.setState({ modal4K: false });
    this.props.setFocus(defaultFocusPath);
  }

  get isReady() {
    return this.state.watchlist && this.state.mystarzlist && !this.state.isEmpty;
  }

  render() {
    return (
      <section>
        <HeadingStyled rank={1} text={i18n.get("pages.myLibrary.mytitle")} />
        {this.state.isLoading ? (
          <Loading overlay />
        ) : this.isReady ? (
          <Fragment>
            {this.loadCarousel(this.state.watchlist, WATCHLIST)}
            {this.loadCarousel(this.state.mystarzlist, MYSTARZLIST)}
          </Fragment>
        ) : !this.state.isEmpty ? (
          <Loading overlay />
        ) : (
          showNoContent(null, this.onClickButton, isAccessLimitedByParentalLevel())
        )}
        {this.state.modal4K && (
          <ModalSettings headingText={""} mainText={i18n.get("global.4Ksupported")}>
            <ButtonModalFocus
              label={i18n.get("global.play4K")}
              focusPath="play4KModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, true)}
              size="small"
              onRef={ref => (this.play4KModalFocusPath = ref)}
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnRight={i18n.directionFlip("@playHDModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.playHD")}
              focusPath="playHDModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, false)}
              size="small"
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@play4KModal_passThru")}
            />
          </ModalSettings>
        )}
      </section>
    );
  }
}

const MyLibrary = withAppState(
  withSubtheme(props => <MyLibraryPage currentFocus={props.applicationState.currentFocus} {...props} />)
);

MyLibrary.defaultFocusPath = defaultFocusPath;

export default MyLibrary;
